/*
 * Broadcast Theme
 *
 * Questo file è pensato per aggiungere codice JavaScript personalizzato al tema Broadcast.
 * Mantenere il codice personalizzato qui faciliterà gli aggiornamenti futuri del tema.
 *
 * NOTA: Per usare questo file, aprire il file /layout/theme.liquid e decomentare l'import dello script custom.js.
 */

let enableDebug = false; // Abilita il debug per il log degli eventi e delle varianti
if (enableDebug) {
  console.log('[Custom JS] Debug mode enabled');
}


let isProductPage = window.location.pathname.includes('/products/');

/*
 * Evento DOMContentLoaded:
 * Questo evento viene eseguito quando l'intero documento HTML è stato caricato e parsificato, 
 * ma non necessariamente quando le immagini e altri contenuti esterni sono completamente caricati.
 * All'interno di questo evento otteniamo la variante iniziale e aggiorniamo lo stato del pulsante ATC.
 */
document.addEventListener('DOMContentLoaded', function() {
  if (!isProductPage) return;

  if (enableDebug) {
    console.log('[Custom JS] DOMContentLoaded event fired');
  }
  
  // add param to URL if not present
  const url = new URL(window.location.href);
  const variantIdParam = url.searchParams.get('variant');
  const variant = getInitialVariant();
 
  if(enableDebug){
    console.log('[Custom JS] Initial variant:', variant);
    console.log('[Custom JS] Variant ID from URL:', variantIdParam);
  }

  if (!variantIdParam && variant) {
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
    console.log('[Custom JS] Updated URL with variant ID:', variant.id);
  }
  
  updateAddToCartState(variant);
});

/*
 * Eventi per il cambio variante:
 * Ascoltiamo sia l'evento nativo del tema Prestige che quello personalizzato.
 * Questo ci permette di gestire il cambio variante in modo più robusto.
 */
document.addEventListener('variant:change', function(e) {
  if (!isProductPage) return;

  if(enableDebug) {
    console.log('[Custom JS] variant:change event fired:', e.detail);
  }
  const variant = e.detail.variant;
  updateAddToCartState(variant);
});

/*
 * Funzione updateAddToCartState(variant):
 * Aggiorna lo stato dei pulsanti "Aggiungi al carrello" e "Notifica disponibilità" in base 
 * alla variante fornita.
 * 
 * Parametri:
 * - variant: Oggetto variante prodotto, o null se non presente.
 *
 * Comportamento:
 * - Se non troviamo i pulsanti necessari, interrompiamo.
 * - Se la variante non esiste, mostriamo l'ATC disabilitato.
 * - Se la variante esiste ma non è disponibile, nascondiamo l'ATC e mostriamo il pulsante di notifica.
 * - Se la variante esiste ed è disponibile, mostriamo l'ATC e nascondiamo il pulsante di notifica.
 */
function updateAddToCartState(variant) {
  // Cerchiamo i pulsanti usando i selettori del tema Prestige
  const addToCartButton = document.querySelector('buy-buttons button.button.w-full');
  const notifyButton = document.querySelector('buy-buttons a.klaviyo-bis-trigger');

  if(enableDebug) {
    console.log('[Custom JS] Updating ATC state with variant:', variant);
    console.log('[Custom JS] Found buttons:', {
      addToCartButton: !!addToCartButton,
      notifyButton: !!notifyButton,
      addToCartButton: !!addToCartButton
    });
  }

  if (!addToCartButton) {
    console.error('[Custom JS] Pulsante ATC non trovato nel DOM');
    return;
  }

  if (!variant) {
    if(enableDebug) {
      console.log('[Custom JS] Nessuna variante selezionata - disabilito ATC');
    }

    addToCartButton.disabled = true;
    if (addToCartButton) {
      addToCartButton.textContent = 'Out of stock';
    }
    if (notifyButton) {
      notifyButton.style.display = 'none';
    }
    return;
  }

  if (!variant.available) {
    if(enableDebug){ 
      console.log('[Custom JS] Variante non disponibile - mostro pulsante notifica');
    }

    addToCartButton.disabled = true;
    if (addToCartButton) {
      addToCartButton.textContent = 'Out of stock';
    }
    if (notifyButton) {
      notifyButton.style.display = 'block';
    }
  } else {
    if(enableDebug) {
      console.log('[Custom JS] Variante disponibile - abilito ATC');
    }
    addToCartButton.disabled = false;
    if (addToCartButton) {
      addToCartButton.textContent = 'Add to cart';
    }
    if (notifyButton) {
      notifyButton.style.display = 'none';
    }
  }
}

/*
 * Funzione getInitialVariant():
 * Recupera la variante iniziale del prodotto basandosi sullo stato attuale della pagina.
 *
 * Comportamento:
 * - Trova il JSON del prodotto nel DOM.
 * - Parse il JSON per ottenere productData.
 * - Se productData non è valido o non contiene varianti, ritorna null.
 * - Cerca nell'URL un parametro "variant" per selezionare una variante specifica.
 * - Se trovata una variante corrispondente a quell'ID, la restituisce.
 * - In caso contrario, restituisce la prima variante disponibile.
 */
function getInitialVariant() {
  // Prima proviamo con il selettore del tema Prestige
  let productJson = document.querySelector('[data-product-json]');
  if(enableDebug) {
    console.log('[Custom JS] Cercando product JSON...');
  }

  if (!productJson) {
    console.error('[Custom JS] Nessun product JSON trovato nel DOM');
    return null;
  }

  let productData;
  try {
    productData = JSON.parse(productJson.innerHTML);
    if(enableDebug) {
      console.log('[Custom JS] Product data parsed:', productData);
    }
  } catch (e) {
    console.error('[Custom JS] Errore nel parsing del product JSON:', e);
    return null;
  }

  if (!productData || !productData.variants || !productData.variants.length) {
    console.error('[Custom JS] Product data non valido o senza varianti:', productData);
    return null;
  }

  // Controlliamo l'URL per il parametro variant
  const url = new URL(window.location.href);
  const variantId = url.searchParams.get('variant');
  
  if (variantId) {
    if(enableDebug) {
      console.log('[Custom JS] Trovato parametro variant nell\'URL:', variantId);
    }
    const urlVariant = productData.variants.find(v => v.id.toString() === variantId);
    if (urlVariant) {
      if(enableDebug) {
        console.log('[Custom JS] Trovata variante dall\'ID URL:', urlVariant);
      }
      return urlVariant;
    }
  }

  // Controlliamo le opzioni selezionate
  const selectedOptions = Array.from(document.querySelectorAll('input:checked[data-option-position]'))
    .map(el => el.dataset.variant);

  if(enableDebug) {
    console.log('[Custom JS] Opzioni selezionate:', selectedOptions);
  }
  
  if (selectedOptions.length) {
    const selectedVariant = productData.variants.find(variant => 
      selectedOptions.every((option, index) => 
        variant[`option${index + 1}`] === option
      )
    );
    if (selectedVariant) {
      if(enableDebug) {
        console.log('[Custom JS] Trovata variante dalle opzioni selezionate:', selectedVariant);
      }
      return selectedVariant;
    }
  }

  // Ritorniamo la prima variante come fallback
  console.log('[Custom JS] Nessuna variante specifica trovata, uso la prima:', productData.variants[0]);
  return productData.variants[0];
}
